import { memo, VFC } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  createStyles({
    xxSmall: {
      height: '8px'
    },
    xSmall: {
      height: '16px'
    },
    small: {
      height: '24px'
    },
    medium: {
      height: '32px'
    },
    large: {
      height: '48px'
    },
    xLarge: {
      height: '56px'
    }
  })
);

type Props = {
  size: 'xxSmall' | 'xSmall' | 'small' | 'medium' | 'large' | 'xLarge';
};

const Spacer: VFC<Props> = props => {
  const { size } = props;
  const classes = useStyles();

  const className = (() => {
    switch (size) {
      case 'xxSmall':
        return classes.xxSmall;
      case 'xSmall':
        return classes.xSmall;
      case 'small':
        return classes.small;
      case 'medium':
        return classes.medium;
      case 'large':
        return classes.large;
      case 'xLarge':
        return classes.xLarge;
    }
  })();

  return <div className={className} />;
};

export default memo(Spacer);
